// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__1AnHL","input":"LoginForm_input__3qzU3","clearInput":"LoginForm_clearInput__qBcCS","error":"LoginForm_error__1usT2"};